<template>

  <div class="page-container" style="width:99%;margin-top:15px;position: absolute;" v-if="distributor == 'ITALY_HINTIME' || distributor == 'SAU_EMS20' ||  distributor == 'MX_30FIT'">
    <el-row :gutter="12" style="display: flex;width: 100%;margin-top: 10px;">
      <el-col :span="24">  
        <el-card>
          <template #header>
            <div class="card-header">
              <span>{{$t('elLocal.userTongji')}}</span>
            </div>
          </template>
          <div >
            <el-table :data="users" style="width: 100%" :header-cell-style="{background:'#00000005'}">
              <el-table-column prop="todayCreate" :label="$t('elLocal.todayCreate')" min-width="20%" align="center"></el-table-column>
              <el-table-column prop="mouthCreate" :label="$t('elLocal.mouthCreate')" min-width="20%" align="center"></el-table-column>
              <el-table-column prop="todayActiv" :label="$t('elLocal.todayActiv')" min-width="20%" align="center" v-if="distributor != 'SAU_EMS20'"></el-table-column>
              <el-table-column prop="mouthActiv" :label="$t('elLocal.mouthActiv')" min-width="20%" align="center" v-if="distributor != 'SAU_EMS20'"></el-table-column>
              <el-table-column prop="allCreate" :label="$t('elLocal.allCreate')" min-width="20%" align="center"></el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="12" style="display: flex;width: 100%;margin-top: 10px;" v-if="distributor != 'SAU_EMS20'">
      <el-col :span="24">  
        <el-card>
          <template #header>
            <div class="card-header">
              <span>{{$t('elLocal.deviceTongji')}}</span>
            </div>
          </template>
          <div >
            <el-table :data="devices" style="width: 100%" :header-cell-style="{background:'#00000005'}">
              <el-table-column prop="todayCreate" :label="$t('elLocal.todayCreateDevice')" min-width="20%" align="center"></el-table-column>
              <el-table-column prop="mouthCreate" :label="$t('elLocal.mouthCreateDevice')" min-width="20%" align="center"></el-table-column>
              <el-table-column prop="todayActiv" :label="$t('elLocal.todayActivDevice')" min-width="20%" align="center"></el-table-column>
              <el-table-column prop="mouthActiv" :label="$t('elLocal.mouthActivDevice')" min-width="20%" align="center"></el-table-column>
              <el-table-column prop="allCreate" :label="$t('elLocal.allCreate')" min-width="20%" align="center"></el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
   
    <el-row :gutter="12" style="display: flex;width: 100%;margin-top: 10px;">  
        <el-col :span="8">
          <el-card   >
            <template #header>
              <div class="card-header">
                <span>{{$t('elLocal.sexTongji')}}</span>
                <!-- <el-button class="button" type="text">操作按钮</el-button> -->
              </div>
            </template>
            <div >
              <el-table :data="userSex" style="width: 100%" :header-cell-style="{background:'#00000005'}">
                <el-table-column prop="sex" :label="$t('elLocal.sex')" min-width="33%" align="center">
                  <template slot-scope="scope">
                    <span >{{scope.row.sex == 0 ? $t('elLocal.sexNan') : scope.row.sex == 1 ? $t('elLocal.sexNvn') : $t('elLocal.unkown') }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="c" :label="$t('elLocal.percentage')"  min-width="33%" align="center">
                  <template slot-scope="scope">
                    <span >{{(scope.row.c *100 / userAll).toFixed(2)  }}%</span>
                  </template>
                </el-table-column>
                <el-table-column prop="c" :label="$t('elLocal.quantity')"  min-width="33%" align="center"></el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>     
        

        <el-col :span="8">
          <el-card>
            <template #header>
              <div class="card-header">
                <span>{{$t('elLocal.ageTongji')}}</span>
                <!-- <el-button class="button" type="text">操作按钮</el-button> -->
              </div>
            </template>
            <div >
              <el-table :data="userAge" style="width: 100%" :header-cell-style="{background:'#00000005'}">
                <el-table-column prop="age" :label="$t('elLocal.age')"  min-width="33%" align="center">
                  <template slot-scope="scope">
                    <span >{{scope.row.age == "--" ? $t('elLocal.unkown') : scope.row.age }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="c" :label="$t('elLocal.percentage')"  min-width="33%" align="center">
                  <template slot-scope="scope">
                    <span >{{(scope.row.c *100 / userAll).toFixed(2)  }}%</span>
                  </template>
                </el-table-column>
                <el-table-column prop="c" :label="$t('elLocal.quantity')" min-width="33%" align="center"></el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card>
            <template #header>
              <div class="card-header">
                <span>{{$t('elLocal.areaTingji')}}</span>
              </div>
            </template>
            <div >
              <el-table :data="userArea" style="width: 100%" :header-cell-style="{background:'#00000005'}">
                <el-table-column prop="country" :label="$t('elLocal.area')"  min-width="50%" align="center">
                  <template slot-scope="scope">
                    <span >{{!scope.row.country || scope.row.country == null ? $t('elLocal.unkown') : scope.row.country }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="c" :label="$t('elLocal.percentage')"  min-width="25%" align="center">
                  <template slot-scope="scope">
                    <span >{{(scope.row.c *100 / userAll).toFixed(2)  }}%</span>
                  </template>
                </el-table-column>
                <el-table-column prop="c" :label="$t('elLocal.quantity')" min-width="25%" align="center"></el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
        
        
      </el-row>

      <el-row :gutter="12" style="display: flex;width: 100%;margin-top: 10px;" v-if="distributor=='SAU_EMS20'">
        <el-col :span="24">  
          <el-card>
            <template #header>
              <div class="card-header">
                <span>{{$t('elLocal.shouru')}}</span>
              </div>
            </template>
            <div >
              <el-table :data="sessions" style="width: 100%" :header-cell-style="{background:'#00000005'}">
                <el-table-column prop="todayCreate" :label="$t('elLocal.todayCreateSales')" min-width="20%" align="center">
                  <template slot-scope="scope">
                    <span >{{(scope.row.todayCreate) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="weekCreate" :label="$t('elLocal.weekCreateSales')" min-width="20%" align="center">
                  <template slot-scope="scope">
                    <span >{{(scope.row.weekCreate) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="mouthCreate" :label="$t('elLocal.mouthCreateSales')" min-width="20%" align="center">
                  <template slot-scope="scope">
                    <span >{{(scope.row.mouthCreate) }}</span>
                  </template>
                </el-table-column>  
                <el-table-column prop="yearCreate" :label="$t('elLocal.yearCreateSales')" min-width="20%" align="center">
                  <template slot-scope="scope">
                    <span >{{(scope.row.yearCreate) }}</span>
                  </template>
                </el-table-column>                
                <el-table-column prop="allCreate" :label="$t('elLocal.allCreate')" min-width="20%" align="center">
                   <template slot-scope="scope">
                    <span >{{(scope.row.allCreate) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import {getStatistics} from '@/api/ydstrong'
  export default {
    data(){
      return {
        users:[],
        devices:[],
        userSex:[],
        userArea:[],
        userAll:1,
        userAge:[],
        sessions:[],
      }
    },

    computed: {
      ...mapState({
        appName: state=>state.app.appName,
        themeColor: state=>state.app.themeColor,
        collapse: state=>state.app.collapse,
        navTree: state=>state.menu.navTree
      }),
      mainTabs: {
        get () { return this.$store.state.tab.mainTabs },
        set (val) { this.$store.commit('updateMainTabs', val) }
      },
      mainTabsActiveName: {
        get () { return this.$store.state.tab.mainTabsActiveName },
        set (val) { this.$store.commit('updateMainTabsActiveName', val) }
      }
    },
    components:{
    },
    created(){
        this.getStatistics();
    },
    methods :{
      getStatistics(){
        getStatistics().then(response => {
          this.users = response.data.users
          this.devices = response.data.devices          
          this.userSex = response.data.userSex
          
          this.userAge = response.data.userAge
          this.userAll = 0;
          for(var i = 0 ; i < this.userAge.length ; i++){
            this.userAll+=this.userAge[i].c
          }
          this.userArea = response.data.userArea
          if(response.data.sessions){
            this.sessions = response.data.sessions
          }
        })
      }
    }
  }
</script>

<style>

  .carousel {
    text-align: center;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: 20px;
  }
  .carousel h2 {
    color: #475669;
    font-size: 22px;
    opacity: 1.75;
    line-height: 100px;
    margin: 0;
  }
  .carousel ul {
    color: #475669;
    font-size: 15px;
    opacity: 1.75;
    line-height: 40px;
    margin: 0;
  }
  .carousel-item-intro h2 {
    color: #ffffff;
    font-size: 22px;
    opacity: 1.75;
    line-height: 80px;
    margin: 0;
  }
  .carousel-item-intro ul {
    color: #ffffff;
    font-size: 15px;
    opacity: 1.75;
    line-height: 65px;
    padding: 5px;
    margin: 0;
  }
   .carousel-item-func h2 {
    color: #3f393b;
    font-size: 22px;
    opacity: 1.75;
    line-height: 50px;
    margin: 0;
  }
  .carousel-item-func ul {
    color: #3f393b;
    font-size: 15px;
    opacity: 1.75;
    line-height: 30px;
    text-align: left;
    padding-left: 90px;
    margin: 0;
  }
  .carousel-item-env h2 {
    color: #475669;
    font-size: 22px;
    opacity: 1.75;
    line-height: 50px;
    margin: 0;
  }
  .carousel-item-env ul {
    color: #475669;
    font-size: 15px;
    opacity: 1.75;
    line-height: 35px;
    text-align: left;
    padding-left: 110px;
    margin: 0;
  }
  .carousel-item-intro {
    background-color: #19aaaf73;
    -webkit-border-radius: 25px;
    border-radius: 25px;
    -moz-border-radius: 15px;
    background-clip: padding-box;
    box-shadow: 0 0 25px #a3b3b965;
  }
  .carousel-item-func {
    background-color: #19aaaf73;
    -webkit-border-radius: 25px;
    border-radius: 25px;
    -moz-border-radius: 15px;
    background-clip: padding-box;
    box-shadow: 0 0 25px #a3b3b965;
  }
  .carousel-item-env {
    background-color: #19aaaf73;
    -webkit-border-radius: 25px;
    border-radius: 25px;
    -moz-border-radius: 15px;
    background-clip: padding-box;
    box-shadow: 0 0 25px #a3b3b965;
  }
  .carousel-item-intro {
    background-color: #b95e5e;
  }
  .carousel-item-func {
    background-color: #52c578;
  }
  .carousel-item-env {
    background-color: #41a7b9;
  }
</style>


// WEBPACK FOOTER //
// src/views/Intro/Intro.vue